import type { ReactNode } from "react";

import { MobileDealShow, MobileReports } from "./MobileReports";
import "@/styles/home.css";
import "@/styles/desk-page.css";

/**
 * Desktop frame for the pages first built for phones (reports, a report's
 * deal): constrained width, a regular page header instead of the
 * sticky mobile one, and a two-column grid where it helps (desk-page.css).
 */
const DeskPage = ({
  children,
  variant,
}: {
  children: ReactNode;
  variant: "reports" | "report";
}) => (
  <div className="desk-page" data-variant={variant}>
    {children}
  </div>
);

export const DeskReports = () => (
  <DeskPage variant="reports">
    <MobileReports />
  </DeskPage>
);

export const DeskDealReport = () => (
  <DeskPage variant="report">
    <MobileDealShow />
  </DeskPage>
);
